import { Component } from "@angular/core"
import { ActivatedRoute } from "@angular/router"
import { NotificationsService } from "angular2-notifications"
import { NgbModal } from "@ng-bootstrap/ng-bootstrap"
import { LMModalService } from "../../services/lm-modal.service"
import { UserService } from "../../services/user.service"
import { EduComponent } from "../../utils/eduComponent"
import Utils from "../../utils/utils"
import { JoinRosterModalComponent } from "../modals/join-roster-modal/join-roster-modal.component"

@Component({
    selector: "app-student-app",
    templateUrl: "./student-app.component.html",
    styleUrls: ["./student-app.component.less"],
})
export class StudentAppComponent extends EduComponent {
    public activeTab: string = "none"
    public notStartedCount: number = null
    public assignments = []
    public enterCode = ""
    public loginFavoriteText =
        "Log In to save links in your Favorites. Search or browse the site without logging in."

    constructor(
        public userService: UserService,
        private lmModalService: LMModalService,
        private modalService: NgbModal,
        private notificationService: NotificationsService,
        private route: ActivatedRoute
    ) {
        super()
        this.register()
    }

    private register() {
        if (!this.userService.hasStudentExperience()) {
            return
        }
        this.userService.loadAssignments()

        this.addSub(
            this.userService.assignments.subscribe((assignments: any) => {
                this.assignments = assignments
                this.notStartedCount = assignments.filter((obj) => {
                    return obj.status === "not_started"
                }).length
            })
        )

        this.addSub(
            this.userService.runOnceForQueryParam(this.route, "code", (code: string) => {
                this.handleRosterJoinLink(code)
            })
        )
        this.checkJoinRosterURL()
    }

    private checkJoinRosterURL() {
        const path = window.location.pathname
        if (!path || !path.startsWith("/student/join/")) {
            return
        }
        const slugs = path.split("/")
        if (slugs.length < 4) {
            return
        }
        this.handleRosterJoinLink(slugs[3])
    }

    private handleRosterJoinLink(code: string) {
        /*
        This handles legacy cases:
        1. Assignment preview (/tools/lessonbuilder/preview/?code=banana9580) We shouldn't do anything here. The
        teacher will see the assignment taking section in the preview mode.
        -> This case will be ignored. The old site iframe will show the preview and no student app section will be open.
        2. Join class link (student/?code=5664bear) The classes tab should open and the join roster modal should open.
        -> Open the classes section and the join classes modal after.

        TODO: Once the preview assignment is in the new site, this should be refactored
         */
        if (!code) {
            return
        }
        if (Utils.isAssignmentCode(code)) {
            return
        }
        if (this.userService.isLoggedIn()) {
            this.activeTab = "classes"
            this.joinClass(code)
        } else {
            this.notificationService.warn(
                "",
                "To enter a class you must be logged in.",
                Utils.alertConfiguration
            )
            this.lmModalService.openLoginModal()
        }
    }

    public toggleTray($event, caller) {
        $event.preventDefault()
        if (!this.userService.isLoggedIn()) {
            this.lmModalService.openLoginModal()
            return
        }
        if (this.userService.isLoggedIn()) {
            if (caller === this.activeTab) {
                this.activeTab = "none"
            } else {
                this.activeTab = caller
            }
        }
    }

    public closeTray() {
        this.activeTab = "none"
    }

    public onFavoriteClick($event) {
        if (!this.userService.isLoggedIn()) {
            this.lmModalService.openLoginModal()
            $event.preventDefault()
            return
        }
    }

    public enterGenericCode(event) {
        event.preventDefault()
        if (this.enterCode) {
            this.userService.enterStudentCode(this.enterCode).subscribe(
                (data: any) => {
                    if (data.url && data.code) {
                        // roster code
                        // window.location.href = data.url;
                        this.activeTab = "classes"
                        this.joinClass(data.code)
                    } else if (data.url && data.url.length > 0) {
                        // assignment code
                        window.location.href = data.url + "?q=code_entered"
                    } else if (data.error) {
                        this.notificationService.error("", data.error, Utils.alertConfiguration)
                    }
                },
                (error) => {
                    this.notificationService.error(
                        "Uh oh!",
                        "Invalid code entered.",
                        Utils.alertConfiguration
                    )
                }
            )
        } else {
            this.notificationService.error("", "Please enter a code", Utils.alertConfiguration)
        }
    }

    private joinClass(code) {
        this.userService.fetchClassDetails(code).subscribe(
            (classDetails: any) => {
                const modal = this.modalService.open(JoinRosterModalComponent)
                modal.componentInstance.rostercode = code
                modal.componentInstance.classInvitation =
                    classDetails.teacher_name + "'s - " + classDetails.name
                modal.componentInstance.classId = classDetails.id
            },
            (error) => {
                this.notificationService.error(
                    "Uh oh!",
                    "Invalid class code.",
                    Utils.alertConfiguration
                )
            }
        )
    }
}
